import { CTA_SUBMIT } from '@actions/types'


export const sendCtaAction = ({ auth, data }) => ({
  type: CTA_SUBMIT,
  payload: {
    request: {
      method: 'post',
      url: `engage/${auth.hash}`,
      data,
      headers: { 'x-api-key': auth.apiKey }
    }
  }
})
